import { useContext } from 'react';
import { AppContextType, WebAppContext } from '../context/app-context';

/**
 * A custom hook for accessing the toast functionality from the WebAppContext.
 *
 * @returns {Object} An object containing the toast function.
 */
const useToast = () => {
  // Extract the toast function from the WebAppContext
  const context = useContext(WebAppContext) as AppContextType;
  if (!context) {
    throw new Error('useToast must be used within a App Context Provider');
  }
  // Return an object with the toast function
  return { toast: context.toast };
};

export default useToast;
